import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconZoomIn } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableMonitoringProfile = (props) => {
  // console.log(props);
  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '100px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            style={{ textAlign: 'center', width: '100%' }}
            className="btn btn-sm btn-outline-success"
            type="button"
            title="Detil Info Kegiatan & Sasaran"
            onClick={() =>
              handleChangePage(
                `/risk-register/${row?.risk_register?.idActivityTarget}`
              )
            }
          >
            <IconZoomIn stroke={2} />
          </button>
        </>
      ),
    },
    {
      name: 'Pernyataan Risiko',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={
          containerStyle
        }>
          <b>{row?.risk_register?.riskStatement}</b>
        </div>
      ),
      style: {
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Akar Masalah',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.rootCause}
          </div>
        </>
      ),
    },
    // {
    //   name: 'Probabilitas (P)',
    //   minWidth: '150px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div
    //         style={{
    //           whiteSpace: 'normal',
    //           wordWrap: 'break-word',
    //           textAlign: 'center',
    //           width: '100%',
    //         }}
    //       >
    //         {row?.risk_register?.probabilityAnalysis}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   name: 'Dampak (D)',
    //   minWidth: '150px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div
    //         style={{
    //           whiteSpace: 'normal',
    //           wordWrap: 'break-word',
    //           textAlign: 'center',
    //           width: '100%',
    //         }}
    //       >
    //         {row?.risk_register?.impactAnalysis}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   name: 'Deteksi',
    //   minWidth: '150px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <>
    //       <div
    //         style={{
    //           whiteSpace: 'normal',
    //           wordWrap: 'break-word',
    //           textAlign: 'center',
    //           width: '100%',
    //         }}
    //       >
    //         {row.controlStatus}
    //       </div>
    //     </>
    //   ),
    // },
    {
      name: 'Hasil Nilai',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.calculateScoring}
          </div>
        </>
      ),
    },
    {
      name: 'Peringkat Unit Kerja',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.rank}
          </div>
        </>
      ),
    },
    {
      name: 'Peringkat RS',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.rankGlobal}
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#198754', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Membuat thead ke tengah
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };
  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <h2 className="text-xl mb-4" style={{ color: '#198754' }}>
          Daftar Profil Pemantauan
        </h2>
        <hr className="my-3" />
        <DataTable
          columns={columns}
          data={props?.listMonitoringProfil}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Profil Pemantauan"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableMonitoringProfile;
